export default ":host {\n  display: block;\n  width: 100%;\n  padding: var(--card-padding);\n}";